import { forwardRef } from 'react';

import { CloseButton, View } from '../style';

import type { DetailedHTMLProps, HTMLAttributes } from 'react';

export type TooltipViewProps = {
  variant: 'primary' | 'outline';
  onCloseClick(): void;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const TooltipView = forwardRef<HTMLDivElement, TooltipViewProps>(function TooltipView(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  { children, variant, onCloseClick, css, ...divProps },
  ref,
) {
  return (
    <View
      ref={ref}
      variant={variant}
      {...divProps}
    >
      <CloseButton variant={variant} onClick={onCloseClick} />
      {children}
    </View>
  );
});
